import { useSelector } from 'react-redux';
import { AppState } from '../../store/appState';
import { useMemo } from 'react';
import { ShopLanguageDetails } from '../../store/authentication/state';

export default function useShopLanguages(): ReadonlyArray<
    Pick<ShopLanguageDetails, 'shopLanguageId' | 'shopLanguageName'>
> {
    const shopLanguages = useSelector((state: AppState) => state.authentication.spoc.shopLanguages);

    return useMemo(() => {
        return [...shopLanguages]
            .sort((a, b) => a.sortIndex - b.sortIndex)
            .map(({ shopLanguageId, shopLanguageName }) => ({ shopLanguageId, shopLanguageName }));
    }, [shopLanguages]);
}
